import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

const COLORS = ["#1A9E5F", "#0F766E", "#38BDF8", "#F59E0B", "#64748B", "#334155"];

export function LeadsBySourceChart({ data = [] }) {
  const chartData = data.map((d) => ({ name: d.source, value: d.count }));
  const total = chartData.reduce((s, d) => s + d.value, 0);

  return (
    <Card className="shadow-sm" data-testid="leads-by-source-chart">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-base font-semibold text-slate-900">Leads by Source</CardTitle>
        <p className="text-xs text-slate-400">Distribution of captured leads across channels</p>
      </CardHeader>
      <CardContent>
        <div className="relative">
          <ResponsiveContainer width="100%" height={260}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                innerRadius={62}
                outerRadius={92}
                paddingAngle={2}
                stroke="none"
              >
                {chartData.map((entry, i) => (
                  <Cell key={entry.name} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{ borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 12 }}
                formatter={(v, n) => [`${v} leads`, n]}
              />
              <Legend
                iconType="circle"
                wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="pointer-events-none absolute left-0 right-0 top-[104px] -translate-y-1/2 text-center">
            <p className="font-mono text-2xl font-bold text-slate-900">{total}</p>
            <p className="text-[11px] uppercase tracking-wider text-slate-400">Total</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
